var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Link } from '@lendi-ui/typography';
import * as React from 'react';
import styled from 'styled-components';
import getColour from '@lendi-ui/commons/colours';
var LinkWrapper = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  text-decoration: none;\n  pointer-events: ", ";\n"], ["\n  color: ", ";\n  text-decoration: none;\n  pointer-events: ", ";\n"])), function () { return getColour('interaction', 'main'); }, function (props) { return (props.wrongNumberClicked ? 'none' : 'auto'); });
export var WrongNumber = function (_a) {
    var onClick = _a.onClick, wrongNumberClicked = _a.wrongNumberClicked;
    return (React.createElement(LinkWrapper, { wrongNumberClicked: wrongNumberClicked, onClick: onClick }, "Wrong number?"));
};
var templateObject_1;
//# sourceMappingURL=index.js.map